import naja from 'naja';
import { LiveForm, Nette } from 'live-form-validation';
import Inputmask from 'inputmask';
import $ from 'jquery';
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.cs';

import qrcode from 'qrcode-generator'; 
import css from "./styles.scss";

$.fn.datepicker.defaults.format = "dd.mm.yyyy";
$.fn.datepicker.defaults.language = "cs";

LiveForm.setOptions({
    showValid: true,
    controlErrorClass: 'input_holder--error',
    controlValidClass: 'input_holder--success',
    showAllErrors: true,
    messageErrorPrefix: '',
    showMessageClassOnParent: 'form-group'
});

global.Nette = Nette;
global.LiveForm = LiveForm;

const NajaLiveValidationFallback = {
    initialize(naja){
        naja.addEventListener('init', function() {
            document.querySelectorAll('input[type="submit"], input[type="button"], form button').forEach(element => {
                element.addEventListener('click', this.processForm);
            });
        }.bind(this));
    },

    processForm(event) {
        const element = event.target;
        if (element.form !== undefined && element.form !== null) {
            element.form['nette-submittedBy'] = element;
        }
    }
}

const NajaPreventDoubleSubmission = {
    initialize(naja){
        naja.addEventListener('init', function() {
            // Prevent Double Submits
            document.querySelectorAll('form').forEach(form => {
                form.addEventListener('submit', (e) => {
                    if ((typeof form.validationState === "undefined") || (form.validationState == true)){
                        // Prevent if already submitting
                        if (form.classList.contains('is-submitting')) {
                            e.preventDefault();
                        }
                        // Add class to hook our visual indicator on
                        form.classList.add('is-submitting');
                    }
                });
            });
        }.bind(this));
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const birthInput = document.querySelector('[name="birth"]');

    if (birthInput) {
        birthInput.addEventListener('blur', function () {
            this.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    naja.registerExtension(NajaLiveValidationFallback);
    naja.registerExtension(NajaPreventDoubleSubmission);
    naja.initialize();
    Nette.initOnLoad();
    naja.snippetHandler.addEventListener('afterUpdate', (event) => {
        $(event.snippet).find('form').each(function() {
            window.Nette.initForm(this);
        });
        $(event.snippet).find('.fade-on-load').each(function(){
            $(this).hide().fadeIn();
        });
    });
    Inputmask().mask(document.querySelectorAll('input[data-inputmask]'));
    Inputmask({
        alias: "datetime",
        inputFormat: "dd.mm.yyyy",
        placeholder: "dd.mm.rrrr",
        showMaskOnHover: false,
        showMaskOnFocus: false,
        clearIncomplete: false,
    }).mask('input[name="birth"]');

    Array.from(document.getElementsByClassName("generate-qr")).forEach((e)=>{
        var qr = qrcode(e.dataset.type ?? 0, e.dataset.erroCorrection ?? 'L');
        qr.addData(e.dataset.data);
        qr.make();
        e.innerHTML =qr.createSvgTag({
            "cellSize" : 4,
            "margin" : 4,
            "scalable" : false
        });
    });
    Array.from(document.querySelectorAll('[data-display-after]')).forEach((e) => {
        const displayDate = new Date(e.dataset.displayAfter * 1000);
        const waitFor = displayDate - Date.now();
        var showElement = ()=>{e.classList.remove('d-none')};
        if (waitFor <= 0){
            showElement()
        } else {
            setTimeout(showElement, waitFor);
        }
    });

    const inputs = document.querySelectorAll('.number_code input');
    const hiddenInput = document.getElementById('kod_register');
    inputs.forEach(input => {
        input.addEventListener('input', () => {
            // Limit input to a single digit
            input.value = input.value.replace(/[^0-9]/g, '');

            // Collect all values
            let code = '';
            inputs.forEach(i => {
                code += i.value.trim();
            });

            // Set the combined code to the hidden input
            hiddenInput.value = code;
        });
    });

    const input = document.querySelector('.focusMe');
    input?.setSelectionRange(input.value.length, input.value.length) || input?.focus();
});
Nette.origIsDisabled = Nette.isDisabled;
Nette.isDisabled = function(elem){
    var result = Nette.origIsDisabled(elem);
    if (!result){
        result = elem.classList.contains('validation-waiting');
    }
    return result;
}

Nette.origValidateForm = Nette.validateForm;
Nette.validateForm = function(sender, onlyCheck){
    var result = Nette.origValidateForm(sender, onlyCheck);
    sender.validationState = result;
    return result;
}

Nette.validators.UIFormJavascriptCallbackValidator_validate = function(elem, args, val) {
    if (args.hasOwnProperty('callback')) {
        if (elem.hasOwnProperty('validationState')){
            switch (elem.validationState){
                case 'valid' : 
                    return true;
                case 'invalid' : 
                    return false;
                case 'waiting' :
                    return ;
            }
        } else {
            elem.addEventListener('change', (event) => {
                elem.validationState = 'changed';
            })
        }
        elem.classList.add('validation-waiting');
        elem.validationState = 'waiting';
                // pro naja 2.5 lze použít string pro identifikaci stornovaného požadavku
        var uniqueId = elem.form.id + '-' + elem.name;
        naja.makeRequest('GET', args.callback, { value: val }, { history: false, snippets: true, abort: false, unique: uniqueId })
            .then((response) => {
                elem.classList.remove('validation-waiting');
                elem.validationState = response.result ? 'valid' : 'invalid';
                if (response.result) {
                    LiveForm.removeError(elem);
                } else {
                    LiveForm.addError(elem,
                        response.hasOwnProperty('message') ? response.message :
                            args.hasOwnProperty('message') ? args.message :
                                'Please enter a valid value.'
                    );
                }
            })
        ;
        return ;
    }
    return true;
};

$(document).on('click', '.toggle_box__item-header, .toggle_box__item-footer', function() {
    $(this).closest(".toggle_box__item").toggleClass('active');
}).on('click', '.main_menu_toggler', function() {
    $(this).toggleClass("active").find('.menu_icon').toggleClass('open');
    $('.main_menu').fadeToggle();

}).on('click', '.fake_select__title', function() {
    $(this).closest('.fake_select').toggleClass('active');
}).on('click', '.brand_select__item', function() {
    $(".device_select__item input:radio[name='zarizeni']").prop('checked', false);
    $('.fake_select__title.model').html('Nejdřív vyberte zařízení');
    $(".fake_select .fake_select__inner input:radio[name='barva']").prop('checked', false);
}).on('click', '.device_select__item', function() {
    $('.fake_select__title.barva').html('Vyberte barvu zařízení');
    $(".fake_select .fake_select__inner input:radio[name='barva']").prop('checked', false);
}).on("click", function(event){
    if(!$(event.target).closest(".fake_select").length){
        $(".fake_select").toggleClass('active', false);
    }
}).on('click', '.fake_select label', function() {
    const $fakeSelect = $(this).closest('.fake_select');
    $fakeSelect.find('.fake_select__title').html('<div class="color_selected">' + $(this).html() + '</div>');
    $fakeSelect.find('.fake_select__inner input').checked = true;
    $fakeSelect.toggleClass('active');
}).on('keypress', 'form', function (e) {
    var code = e.keyCode || e.which;
    if (code == 13) {
        e.preventDefault();
        $('input[type=submit][name=submit]').click();
        return false;
    }
}).on('submit', 'form', function() {
    var $this = $(this);
    if (typeof $this.valid == 'undefined'){
        return true;
    }
    if (!$(this).valid()) return false;
    $('input[type=submit]').attr("disabled", "disabled");
    return true;
}).on('click', '.modal_wrapper .close_modal', function(e){
    e.preventDefault();
    $(this).closest(".modal_wrapper").fadeOut();
}).on('hide', '[data-provide="datepicker"]', function(){
    Nette.validateControl(this);
}).on('input', '.number_code input', function(){

    // Get the current input field
    var $this = $(this);

    // Ensure only one number is entered
    var value = $this.val().replace(/[^0-9]/g, '');
    $this.val(value);

    // Add the "filled" class if there is a number, otherwise remove it
    if (value) {
        $this.addClass('filled');
    } else {
        $this.removeClass('filled');
    }

    // Automatically move to the next input if there is a number
    if (value) {
        var $nextInput = $this.nextAll('input').first();

        if ($nextInput.length > 0) {
            // Focus the next input
            $nextInput.focus();
        } else {
            // Check if all inputs are filled before submitting the form
            var $form = $this.closest('form');
            var allFilled = $this.closest('.number_code').find('input').toArray().every(function (input) {
                return $(input).val().trim() !== '';
            });

            if (allFilled) {
                // Dispatch a submit event to trigger any submit listeners
                const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
                if ($form[0].dispatchEvent(submitEvent)) {
                    // Only submit programmatically if the event was not canceled
                    $form[0].submit();
                }
            }
        }
    }

}).on('keydown', '.number_code input', function (e) {
    const $this = $(this);
    if (e.key === 'Backspace' && !$this.val()) {
        const $prevInput = $this.prevAll('input').first();
        if ($prevInput.length > 0) {
            $prevInput.focus();
        }
    }
});